import { useTranslation } from "react-i18next";
import { Languages, DEFAULT_LANGUAGE } from "@Constants";
import { useLocalStorage } from "@uidotdev/usehooks";

const useLocalization = () => {
  const [language, setLangauge] = useLocalStorage<string>(
    "language",
    DEFAULT_LANGUAGE.value
  );
  const { i18n, t: translate } = useTranslation();

  const handleChangeLanguage = (newlang: string) => {
    i18n.changeLanguage(newlang);
    setLangauge(newlang);
  };

  return {
    onChangeLanguage: handleChangeLanguage,
    translate: translate,
    currentLanguage: language,
    allLanguages: Languages,
  };
};

export default useLocalization;
